/* eslint-disable */
// Real portfolio data extracted from Sanity CMS
// Image URLs will need to be downloaded and placed in /public/assets/

// Helper function to generate Sanity CDN URLs
const getSanityImageUrl = (ref) => {
  if (!ref) return "/assets/placeholder.svg";
  const parts = ref.split('-');
  if (parts.length < 3) return "/assets/placeholder.svg";
  const id = parts.slice(1, -2).join('-');
  const dimensions = parts[parts.length - 2];
  const format = parts[parts.length - 1];
  return `https://cdn.sanity.io/images/89glztef/production/${id}-${dimensions}.${format}`;
};

export const abouts = [
  {
    title: "Frontend Development",
    description: "Building responsive, performant, and accessible web applications with modern frameworks and best practices. Focus on component architecture, state management, and optimal user experiences.",
    imgUrl: getSanityImageUrl("image-1d0c9d2ae2d9aa3c2a3bc85c89c88ecf46a6aee7-1213x797-png")
  },
  {
    title: "Backend/Databases Development",
    description: "Designing and implementing scalable server-side applications, RESTful APIs, and microservices. Expertise in database design, authentication, and system architecture.",
    imgUrl: getSanityImageUrl("image-516787437c90a40e57bec2967263e0d269b47f23-1128x871-png")
  },
  {
    title: "AI Engineer",
    description: "Developing intelligent applications using machine learning models, generative AI, and LLMs. Building AI-powered features and automation solutions.",
    imgUrl: getSanityImageUrl("image-826528fffb99022b6abda53c963448373d818add-1163x622-png")
  },
  {
    title: "Cloud Development",
    description: "Architecting and deploying cloud-native applications with focus on scalability, security, and cost optimization. Experience with serverless architectures and containerization.",
    imgUrl: getSanityImageUrl("image-7669f2af420de8874af6760d7dbc7d2accf90c99-912x829-png")
  },
  {
    title: "Mobile Development",
    description: "Creating cross-platform mobile applications with native performance. Expertise in building responsive designs for smartphones and tablets across iOS and Android.",
    imgUrl: getSanityImageUrl("image-edd567d4b96e0d8565c5e0684c380bfeab1a5ebe-1128x811-png")
  }
];

// Simplified roles for home page
export const roles = [
  {
    title: "Frontend",
    icon: "SiReact"
  },
  {
    title: "Backend",
    icon: "FaServer"
  },
  {
    title: "MOBILE",
    icon: "MdPhoneIphone"
  },
  {
    title: "CLOUD",
    icon: "SiAmazonaws"
  },
  {
    title: "AI",
    icon: "SiOpenai"
  }
];

export const works = [
  {
    title: "Cenomi Plus iOS Android",
    description: "Team Lead & Development",
    projectLink: "https://apps.apple.com/sa/app/cenomi-plus/id6742008986",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-e87611fd37d94ab3836d1d03a14dfce90bd72014-500x500-png"),
    tags: ["Mobile Apps", "Backend/Databases", "Cloud/System-Design/AI"]
  },
  {
    title: "Priceless.com",
    description: "AWS ECS Lambda EC2 RDS - POCs & Implementations",
    projectLink: "https://www.priceless.com",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-c59d69cb093e0d06d7021d871b257d0738bcb3c1-957x843-png"),
    tags: ["Cloud/System-Design/AI", "Backend/Databases"]
  },
  {
    title: "Mastercard",
    description: "Experiences Platform",
    projectLink: "https://mastercard.com",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-8163e2a72c7199c0e6b005a3e5005fdec5d1c3a5-500x500-png"),
    tags: ["Web Apps", "Backend/Databases", "Cloud/System-Design/AI"]
  },
  {
    title: "Geekyants - Rescue Apps",
    description: "Native iOS, Android, React Apps",
    projectLink: "https://geekyants.com",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-20b82fbbceb3ef5ec14a341f078c616c565d1c75-500x500-png"),
    tags: ["Mobile Apps", "Web Apps"]
  },
  {
    title: "Cost Calculator",
    description: "Calculates Cost Of Making Apps",
    projectLink: "https://play.google.com/store/apps/details?id=com.redbytes.projectcostcalculator",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-050d1234e6b032e93dbf02aec82f8dd567857f11-512x512-png"),
    tags: ["Mobile Apps", "Backend/Databases", "Cloud/System-Design/AI"]
  },
  {
    title: "Dcoder",
    description: "Online Coding Platform",
    projectLink: "https://dcoder.tech",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-b1cad6a17a36989ef652172ae7a3787f3bff58eb-500x500-png"),
    tags: ["Web/Mobile Apps", "Mobile Apps", "Web Apps"]
  },
  {
    title: "Scale Hub",
    description: "Rendernetworks Data Engineering",
    projectLink: "https://www.rendernetworks.com/platform",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-0a7099ac6b5010c9a4e5f3eb27234d3697c3fb06-500x500-png"),
    tags: ["Backend/Databases", "Web Apps", "Cloud/System-Design/AI"]
  },
  {
    title: "Apux",
    description: "ABB's UI Component Library",
    projectLink: "https://global.abb//group/en/technology",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-788b5966f8accf0141843fb41a635a26fc5ddf19-500x500-png"),
    tags: ["Web Apps"]
  },
  {
    title: "Student App - Edsys",
    description: "Learning Management Mobile App",
    projectLink: "https://play.google.com/store/apps/details?id=com.edsys.student",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-e87611fd37d94ab3836d1d03a14dfce90bd72014-500x500-png"),
    tags: ["Mobile Apps", "Backend/Databases", "Cloud/System-Design/AI"]
  },
  {
    title: "Generative AI - Chat bot Integrations",
    description: "AI/LLM/RAG",
    projectLink: "",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-826528fffb99022b6abda53c963448373d818add-1163x622-png"),
    tags: ["Cloud/System-Design/AI", "Web Apps"]
  },
  {
    title: "Jatya",
    description: "Clinic Management App",
    projectLink: "https://webknot.in",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-027e4a37b44744c44de7675ecc4021bd1cfeed78-500x500-png"),
    tags: ["Backend/Databases", "Web Apps", "Cloud/System-Design/AI"]
  },
  {
    title: "Gardian-EMS",
    description: "A Health Care App",
    projectLink: "https://webknot.in",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-cdb91c9fb1ad9fd30222acc265ccd66d893cdd43-500x500-png"),
    tags: ["Web Apps", "Backend/Databases"]
  },
  {
    title: "Spykke Charge2Win",
    description: "Powerbank Rental",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-2d7794d023a05584648333896dd9ed46c527c2f6-500x500-png"),
    tags: ["Web Apps", "Backend/Databases"]
  },
  {
    title: "Friends Hub",
    description: "A Social Media Friend Request App",
    projectLink: "",
    codeLink: "https://github.com/varanbhalla/friends-app",
    imgUrl: getSanityImageUrl("image-8163e2a72c7199c0e6b005a3e5005fdec5d1c3a5-500x500-png"),
    tags: ["Web Apps", "Backend/Databases", "Cloud/System-Design/AI"]
  },
  {
    title: "Image Processor",
    description: "Compression for Png & Jpg Images",
    projectLink: "",
    codeLink: "https://github.com/varanbhalla/image-processor",
    imgUrl: getSanityImageUrl("image-a3793d7f30e45d94c871f11b23549de09b73555b-500x500-png"),
    tags: ["Web Apps", "Backend/Databases"]
  },
  {
    title: "eDocs",
    description: "Document Sharing & Tracking",
    projectLink: "https://www.redbytes.in",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-b0744f69918caa57c4822660c4812392b908d67e-500x500-png"),
    tags: ["Mobile Apps"]
  },
  {
    title: "Pets",
    description: "Pet Care Mobile App",
    projectLink: "https://www.redbytes.in",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-20b82fbbceb3ef5ec14a341f078c616c565d1c75-500x500-png"),
    tags: ["Mobile Apps"]
  },
  {
    title: "Ransomware - Ethical Hacking",
    description: "Learning Cyber Security",
    projectLink: "",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-9f8db954b10ac8710fe39cc849ac8970745f3621-500x500-png"),
    tags: ["Others"]
  },
  {
    title: "Students Marks Prediction",
    description: "Machine Learning Model",
    projectLink: "",
    codeLink: "",
    imgUrl: getSanityImageUrl("image-c1bc5ea65a8a3c2fc6a0a33e94ea4d5b7836a2b1-500x500-png"),
    tags: ["Others"]
  }
];

export const experiences = [
  {
    year: "2026",
    works: [
      {
        name: "Team Lead & Development",
        company: "Cenomi Plus",
        desc: "React/Next, React-Native, iOS, Android, AppStore, PlayStore, AI Integrations, Firebase, Python",
        deliverables: [
          "Collaborated with mobile, web, product, design, security and ai teams.",
          "Worked on app design, planning, development, testing and release.",
          "AI driven initiatives, code reviews, app releases"
        ]
      }
    ]
  },
  {
    year: "2025-2026",
    works: [
      {
        name: "Software Engineer II",
        company: "Mastercard",
        desc: "React/Next, Typescript, Python, AWS, SQL, Experiences, Payments, MicroServices",
        deliverables: [
          "Building enterprise-scale web and backend systems in the payments and experiences domain",
          "Designing and maintaining scalable monolith and microservices-based architectures",
          "Developing user-facing features and secure, high-performance APIs",
          "AI Engineering initiatives, working with distributed teams",
          "Collaborations with platform, product, testing and business teams",
          "Contributed to system design for servers, databases, documentation",
          "Ensuring production-grade quality, end-to-end testing, code reviews"
        ]
      }
    ]
  },
  {
    year: "2023-2024",
    works: [
      {
        name: "Sr Software Engineer",
        company: "Webknot Technologies",
        desc: "React-Native, React, Next, Python, Node, AWS, Typescript, MicroFrontends, Android, iOS, Supabase",
        deliverables: [
          "Worked on large-scale web and mobile products like Geekyants, Render Networks, Pixid.ai, and Jatya",
          "Led performance improvements for React MicroFrontends, Python, AWS",
          "Built Node.js and FastAPI backend services, automations, data engineering, visualization, dashboards, integrations",
          "Feature implementation on modules like maps, gps, os, media, gallery, responsiveness, multi-lang, react-native upgrades, etc for iPads, iPhones, web, android, tablets",
          "Implemented native Android (Kotlin) and iOS (Swift) features along with React Native Modules for performance critical features",
          "Allied with global teams from Canada, UK, India, Australia"
        ]
      }
    ]
  },
  {
    year: "2022",
    works: [
      {
        name: "Software Developer",
        company: "Webknot Technologies",
        desc: "React, React-Native, Node, MongoDB, AWS, Typescript, Jest, Sonarqube, Sass, Redux",
        deliverables: [
          "Contributed to healthcare and industrial automation products like ABB, Gardian EMS platforms",
          "Delivered 250+ improvements across frontend, backend with stability and user experience, part of deployment and release cycles",
          "Application performance optimization, enterprise-scale applications for ABB's R&D teams",
          "Practiced test-driven development, enforced code quality using SonarQube, efficient communications"
        ]
      }
    ]
  },
  {
    year: "2021",
    works: [
      {
        name: "Jr Software Engineer",
        company: "Redbytes Software",
        desc: "React, React-Native, Node, MongoDB, AWS",
        deliverables: [
          "Worked on the company's flagship Cost Calculator mobile app (10,000+ downloads)",
          "Developed backend REST APIs, core functionalities, and UI components",
          "Built image gallery, call scheduling, cost calculation, calendar features",
          "Deployed Android builds and fixed production crashes, Google Play Store",
          "Contributed to multiple products like Edsys, Pets, and Edocs"
        ]
      },
      {
        name: "Full Stack Developer - Internship",
        company: "Dcoder",
        desc: "React, Node, MongoDB, Bootstrap, Material UI",
        deliverables: [
          "Built drag-and-drop image gallery taking reference from Trello",
          "Implemented REST APIs and data handling for video embedding using YouTube SDK",
          "Developed responsive UIs from scratch with reusable components and theming",
          "Collaborated with stakeholders from TechStars"
        ]
      },
      {
        name: "Full Stack Developer - Internship",
        company: "Algomastery",
        desc: "React, Node, AWS, MongoDB",
        deliverables: [
          "Built and deployed an end-to-end web application on AWS with Serverless",
          "Implemented rate limiting and caching on REST APIs to reduce database load",
          "Improved network performance by ~25% for search and filtering features",
          "Learnt the benefits of serverless architecture over servers for unpredictable loads"
        ]
      }
    ]
  }
];

export const skills = [
  {
    name: "React/Next.js",
    icon: "SiReact"
  },
  {
    name: "React Native",
    icon: "SiReact"
  },
  {
    name: "JavaScript/TypeScript",
    icon: "SiTypescript"
  },
  {
    name: "Node.js/Express",
    icon: "SiNodedotjs"
  },
  {
    name: "Python",
    icon: "SiPython"
  },
  {
    name: "FastAPI",
    icon: "SiFastapi"
  },
  {
    name: "AI Engineering",
    icon: "GiBrain"
  },
  {
    name: "Gen AI Tools",
    icon: "SiOpenai"
  },
  {
    name: "Claude",
    icon: "GiBrain"
  },
  {
    name: "AWS",
    icon: "SiAmazonaws"
  },
  {
    name: "Langchain",
    icon: "GiChainLightning"
  },
  {
    name: "Containers",
    icon: "SiDocker"
  },
  {
    name: "MongoDB",
    icon: "SiMongodb"
  },
  {
    name: "PostgreSQL",
    icon: "SiPostgresql"
  },
  {
    name: "Supabase",
    icon: "SiSupabase"
  },
  {
    name: "GraphQL",
    icon: "SiGraphql"
  },
  {
    name: "Microservices",
    icon: "AiOutlineCluster"
  },
  {
    name: "System Design",
    icon: "MdArchitecture"
  },
  {
    name: "Full Stack",
    icon: "FaLayerGroup"
  },
  {
    name: "HTML/CSS",
    icon: "SiHtml5"
  },
  {
    name: "CI/CD",
    icon: "SiGithubactions"
  },
  {
    name: "Testing",
    icon: "SiJest"
  },
  {
    name: "Git/Github",
    icon: "SiGithub"
  },
  {
    name: "DSA",
    icon: "FaCodeBranch"
  },
  {
    name: "Java/SpringBoot",
    icon: "SiJava"
  }
];

export const testimonials = [
  {
    name: "Gardian EMS",
    company: "Ondace",
    imgurl: getSanityImageUrl("image-ab90786c86ae798a96aab4ff16e0d04ad20490ae-500x500-png"),
    feedback: ""
  },
  {
    name: "dcoder.tech",
    company: "Dcoder",
    imgurl: getSanityImageUrl("image-b1cad6a17a36989ef652172ae7a3787f3bff58eb-500x500-png"),
    feedback: ""
  },
  {
    name: "Student Learning App",
    company: "Redbytes Software",
    imgurl: getSanityImageUrl("image-e87611fd37d94ab3836d1d03a14dfce90bd72014-500x500-png"),
    feedback: ""
  },
  {
    name: "Cost Calculator",
    company: "Redbytes Software",
    imgurl: getSanityImageUrl("image-050d1234e6b032e93dbf02aec82f8dd567857f11-512x512-png"),
    feedback: ""
  }
];

export const brands = [];
